export enum PageType {
	STANDARD = 'standard',
	FULLSCREEN = 'fullscreen',
}
